<template>
  <div class="task-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="banner">
        <van-swipe :autoplay="3000" indicator-color="white" :loop="true" class="banner-swipe">
          <van-swipe-item v-for="(img, idx) in bannerImages" :key="idx">
            <van-image :src="img" fit="cover" class="banner-img" />
            <div class="banner-overlay">
              <template v-if="idx % 2 === 0">
                <div class="overlay-title">{{ setA.title }}</div>
                <div class="overlay-sub">{{ setA.sub }}</div>
              </template>
              <template v-else>
                <div class="overlay-title">{{ setB.title }}</div>
                <div class="overlay-sub">{{ setB.sub }}</div>
              </template>
            </div>
          </van-swipe-item>
        </van-swipe>
        <!-- 搜索框叠加在轮播图上方 -->
        <div class="banner-search">
          <van-search
            v-model="value"
            placeholder="请输入搜索内容"
            shape="round"
            @search="onSearch"
          />
        </div>
      </div>

      <div class="section-head">
        <div class="section-title emphasis">管理中心</div>
      </div>

      <div class="shortcut-nav">
        <div class="shortcut-item highlight-item" @click="goCheckIn">
          <div class="shortcut-icon check-in-icon"><van-icon name="photograph" /></div>
          <div class="shortcut-text">今日打卡</div>
        </div>
        <div class="shortcut-item" @click="goMyProject">
          <div class="shortcut-icon"><van-icon name="orders-o" /></div>
          <div class="shortcut-text">我的项目</div>
        </div>
        <div class="shortcut-item" @click="goUserInfo">
          <div class="shortcut-icon"><van-icon name="contact-o" /></div>
          <div class="shortcut-text">我的信息</div>
        </div>
        <div class="shortcut-item" @click="goTaxQuery">
          <div class="shortcut-icon"><van-icon name="gold-coin-o" /></div>
          <div class="shortcut-text">个税计算器</div>
        </div>
        <div class="shortcut-item" @click="goAbout">
          <div class="shortcut-icon"><van-icon name="info-o" /></div>
          <div class="shortcut-text">关于我们</div>
        </div>
      </div>

      <div class="section-head">
        <div class="section-title emphasis">任务列表</div>
      </div>

      <van-list
        v-model="loading"
        :finished="finished"
        success-text="刷新成功"
        finished-text="没有更多了"
        @load="getList"
        :immediate-check="false"
      >
        <div v-for="(fa,i) in listData" :key="i">
          <div class="job-card" v-for="(item, j) in fa" :key="item.id" @click="taskInfo(item)">
            <div class="job-main">
              <div class="job-thumb">
                <van-image :src="getCardImage(i, j, item)" fit="cover" class="thumb-img" />
              </div>
              <div class="job-left">
                <div class="job-title">{{item.name}}</div>
                <div class="job-meta">发布企业: {{displayMerchantName(item.merchantName)}}</div>
                <div class="job-bottom">
                  <van-icon name="clock-o" />
                  <span class="bottom-text">发布时间: {{displayCreateTime(item)}}</span>
                </div>
              </div>
              <div class="job-right">
                <div class="salary-badge">{{displaySalaryRange(item)}}元</div>
                <div class="action-btns">
                  <van-button class="btn-outline" size="small" type="primary" plain @click.stop="taskInfo(item)">查看详情 > </van-button>
                </div>
              </div>
            </div>
            <div class="job-desc-bottom">
              <span class="desc-text">{{ item.describe }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-empty description="没有更多数据了" v-if="listData.length === 0" />
    <footer-menu></footer-menu>
  </div>
</template>
<script>
import requestHTAPI from '@/axios/HantangTax'
import footerMenu from '@/components/footer/FooterMenu'
import banner1 from '@/assets/banner1.png'
import banner2 from '@/assets/banner2.png'
import banner3 from '@/assets/banner3.png'
import banner4 from '@/assets/banner4.png'
import banner5 from '@/assets/banner5.png'
import imgTech from '@/assets/computer.png'
import imgPeople from '@/assets/person.png'
import logo from '@/assets/logo.png'
export default {
  name: 'TaskHome',
  components: {
    footerMenu
  },
  data () {
    return {
      value: '',
      // 搜索关键词（由搜索框设置，用于 name 模糊过滤）
      searchKeyword: '',
      // 搜索防抖定时器
      searchTimer: null,
      listData: [],
      loading: false,
      finished: false,
      refreshing: false,
      total: 0,
      bannerImages: [banner1, banner2, banner3, banner4, banner5],
      setA: { title: '找任务，赚酬金，这里更高效', sub: '优质任务速对接，收益轻松拿' },
      setB: { title: '任务大厅：你的灵活增收平台!', sub: '精准匹配需求，接单快人一步' },
      // 为缺省的发布时间提供稳定的随机值缓存（按项目 id 缓存）
      fallbackCreateTimes: {},
      // 为薪酬区间显示提供稳定的随机值缓存（按项目 id 缓存）
      fallbackSalaryRanges: {},
      fallbackDescriptions: {},
      categoryImages: { tech: imgTech, market: imgPeople, info: imgPeople, other: logo },
      formData: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created () {

  },
  methods: {
    // 重置分页与列表数据，以便搜索或下拉刷新后重新拉取
    resetListState () {
      this.formData.pageNum = 1
      this.listData = []
      this.finished = false
    },
    // 显示打码后的企业名：保留前2字，尾部保留公司后缀
    displayMerchantName (name) {
      if (!name || typeof name !== 'string') return '某某***公司'
      const suffixes = [
        '技术方案', '信息技术有限公司', '网络科技有限公司', '数据科技有限公司',
        '有限公司', '公司', '集团'
      ]
      const found = suffixes.find(s => name.endsWith(s))
      if (found) {
        const body = name.slice(0, name.length - found.length)
        const keep = body.slice(0, 2)
        return `${keep}***${found}`
      }
      // 无后缀匹配时，简单打码
      return `${name.slice(0, 2)}***`
    },
    // 当发布时间为空时，显示最近一个月内的随机时间，并缓存保证稳定
    displayCreateTime (item) {
      const val = item && item.createTime
      if (val && String(val).trim()) return val
      const id = item && (item.id || item.sId)
      if (id && this.fallbackCreateTimes[id]) return this.fallbackCreateTimes[id]
      const generated = this.formatDate(this.getRandomDateWithinLastMonth())
      if (id) {
        this.fallbackCreateTimes[id] = generated
      } else if (item) {
        // 无法识别 id 时，直接在对象上做一次性缓存
        item.__fallbackCreateTime = item.__fallbackCreateTime || generated
        return item.__fallbackCreateTime
      }
      return generated
    },
    // 生成最近一个月内的随机时间
    getRandomDateWithinLastMonth () {
      const now = new Date()
      const start = new Date(now)
      start.setMonth(now.getMonth() - 1)
      const startMs = start.getTime()
      const endMs = now.getTime()
      const randMs = startMs + Math.random() * (endMs - startMs)
      return new Date(randMs)
    },
    // 格式化为 YYYY-MM-DD HH:mm:ss
    formatDate (date) {
      const pad = (n) => String(n).padStart(2, '0')
      const y = date.getFullYear()
      const m = pad(date.getMonth() + 1)
      const d = pad(date.getDate())
      const h = pad(date.getHours())
      const min = pad(date.getMinutes())
      const s = pad(date.getSeconds())
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },
    // 生成 1-50000 的随机金额区间，并缓存保证稳定
    displaySalaryRange (item) {
      const id = item && (item.id || item.sId)
      const cat = this.getServiceCategory(item)
      if (id && this.fallbackSalaryRanges[id]) return this.fallbackSalaryRanges[id]
      if (item && item.__fallbackSalaryRange) return item.__fallbackSalaryRange
      const generated = this.getRandomSalaryRange(cat)
      if (id) {
        this.fallbackSalaryRanges[id] = generated
      } else if (item) {
        item.__fallbackSalaryRange = generated
        return item.__fallbackSalaryRange
      }
      return generated
    },
    getServiceCategory (item) {
      const t = (item && (item.category || item.type || item.serviceType)) || ''
      const name = String(item && item.name || '').toLowerCase()
      const text = String(t || '').toLowerCase()
      const isHR = ['人力资源','人力','hr','人事','招聘','薪酬','员工关系','培训','劳动法'].some(k => name.includes(k.toLowerCase()) || text.includes(k.toLowerCase()))
      if (isHR) return 'hr'
      const isMarket = ['市场','推广','营销','运营','销售','商务','地推','活动','会务','bd','新媒体','内容运营'].some(k => name.includes(k.toLowerCase()) || text.includes(k.toLowerCase()))
      if (isMarket) return 'market'
      const isInfo = ['信息服务','信息','客服','文员','行政','翻译','文案','编辑','写作','标注'].some(k => name.includes(k.toLowerCase()) || text.includes(k.toLowerCase()))
      if (isInfo) return 'info'
      const isTech = ['技术','开发','前端','后端','测试','工程师','java','python','node','算法','ai','运维','数据开发'].some(k => name.includes(k.toLowerCase()) || text.includes(k.toLowerCase()))
      if (isTech) return 'tech'
      return 'other'
    },
    getRandomSalaryRange (category) {
      const randomStep = (min, max, step) => {
        const steps = Math.floor((max - min) / step) + 1
        const idx = Math.floor(Math.random() * steps)
        return min + idx * step
      }
      const MAX = 5000
      const ranges = {
        market: [2500, 4200],
        tech: [3000, 4800],
        info: [800, 3800],
        hr: [2000, 4500],
        other: [1500, 4300]
      }
      const [minLow, maxLow] = ranges[category] || ranges.other
      const low = randomStep(minLow, Math.min(maxLow, MAX - 500), 100)
      const high = randomStep(Math.min(low + 200, MAX - 200), MAX, 100)
      return `${low}-${high}`
    },
    generateRandomRequirements (item) {
      const id = item && (item.id || item.sId)
      if (id && this.fallbackDescriptions[id]) return this.fallbackDescriptions[id]
      if (item && item.__fallbackDesc) return item.__fallbackDesc
      const cat = this.getServiceCategory(item)
      const market = ['熟悉线上线下渠道投放','具备数据分析与ROI意识','能撰写活动文案与素材协同','沟通与执行力强','熟练使用Excel或统计工具','有市场活动经验','能独立推进地推/会务']
      const tech = ['熟悉HTML/CSS/JavaScript','掌握至少一种后端语言','熟悉数据库与接口调试','具备基本性能优化意识','能进行接口对接与调试','懂版本管理与日志','具备单元测试与问题定位能力']
      const info = ['沟通耐心细致','具备基础办公软件能力','打字与记录规范','熟悉客服或行政流程','具备数据统计与表格处理能力','有文案编辑与排版基础','执行力与配合度良好']
      const hr = ['涵盖招聘、薪酬福利、员工关系、培训发展模块','具备沟通协调能力','熟悉劳动法与合规政策','搭建人力资源体系','优化员工管理流程','推动绩效与晋升机制','完善入转离全流程','擅长组织与跨部门协作']
      const other = ['responsibility','沟通协作能力良好','按流程规范执行','能按时保质完成交付','具备基本文档与记录能力','学习与适应能力较好']
      const pool = cat === 'market' ? market : cat === 'tech' ? tech : cat === 'info' ? info : cat === 'hr' ? hr : other
      const pickN = (arr, n) => {
        const a = arr.slice()
        const res = []
        const c = Math.min(n, a.length)
        for (let i = 0; i < c; i++) {
          const idx = Math.floor(Math.random() * a.length)
          res.push(a.splice(idx, 1)[0])
        }
        return res
      }
      const parts = pickN(pool, 3)
      const text = `基本要求：${parts.join('；')}。`
      if (id) {
        this.fallbackDescriptions[id] = text
      } else if (item) {
        item.__fallbackDesc = text
        return item.__fallbackDesc
      }
      return text
    },
     truncateText (text, limit = 10) {
      const s = typeof text === 'string' ? text : ''
      return s.length > limit ? s.slice(0, limit) + '...' : s
    },
    getCardImage (rowIdx, colIdx, item) {
      const list = this.bannerImages || []
      const len = list.length || 1
      const idx = (Number(rowIdx) + Number(colIdx)) % len
      return list[idx]
    },
    getList () {
      // 标记为加载中，便于 van-list 正确展示加载状态
      this.loading = true
      requestHTAPI.projectList({
        ...this.formData,
        // 后端按名称检索（若不支持将退化为本地过滤逻辑）
        name: (this.searchKeyword || '').trim()
      }).then(res => {
        this.loading = false
        // 结束下拉刷新动画（若存在）
        this.refreshing = false
        if (res.data.code === '0000') {
          const payload = res.data.data || res.data || {}
          const rows = Array.isArray(payload.rows)
            ? payload.rows
            : Array.isArray(payload.list)
              ? payload.list
              : Array.isArray(payload.records)
                ? payload.records
                : []

          if (rows.length > 0) {
            // 根据搜索关键词进行 name 模糊过滤（不区分大小写）
            const keyword = String(this.searchKeyword || '').toLowerCase()
            const filtered = keyword
              ? rows.filter(r => String(r && r.name || '').toLowerCase().includes(keyword))
              : rows
            // 根据项目名称生成技能/条件描述，覆盖展示用的描述
            filtered.forEach(r => {
              r.describe = this.generateRandomRequirements(r)
            })
            // 将当前页的（可能过滤后的）结果加入列表（空结果不推入，避免占位）
            if (filtered.length > 0) {
              this.listData.push(filtered)
            }
            const currentPage = payload.pageNum ?? payload.page ?? payload.current ?? this.formData.pageNum
            const pageSize = payload.pageSize ?? payload.size ?? this.formData.pageSize
            this.formData.pageNum = Number(currentPage) + 1
            this.formData.pageSize = Number(pageSize)
            // 若服务端已按 name 过滤，则 rows 就是命中项；否则用本地过滤结果判断
            this.finished = (this.searchKeyword ? filtered.length : rows.length) < this.formData.pageSize
            // 如果是搜索模式且当前页无命中，则直接结束，避免持续拉取多页造成卡顿
            if (this.searchKeyword && filtered.length === 0) {
              this.finished = true
            }
          } else {
            this.finished = true
          }
        } else {
          // 接口异常时不展示任何假项目
          this.finished = true
          this.$notify({ type: 'warning', message: res.data.message || '接口异常' })
        }
      }).catch(() => {
        this.loading = false
        this.refreshing = false
      })
    },
    onRefresh () {
      // 下拉或程序触发刷新均重置并重新拉取
      this.resetListState()
      this.loading = true
      this.getList()
    },
    onSearch () {
      // 防抖：避免快速输入造成的连环请求
      const kw = (this.value || '').trim()
      this.searchKeyword = kw
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
      this.searchTimer = setTimeout(() => {
        this.resetListState()
        this.getList()
      }, 300)
    },
    taskInfo (item) {
      const id = item.id
      const createTime = this.displayCreateTime(item)
      const salaryRange = this.displaySalaryRange(item)
      this.$router.push({
        name: 'TaskInfo',
        query: {
          id,
          createTime,
          salaryRange,
          describe: item.describe,
          source: 'taskHome'
        }
      })
    },
    applyNow (item) {
      this.taskInfo(item)
    },
    goMyProject () {
      this.$router.push({ name: 'myPro' })
    },
    goCheckIn () {
      this.$router.push({ name: 'CheckIn' })
    },
    goUserInfo () {
      this.$router.push({ name: 'userInfo' })
    },
    goTaxQuery () {
      window.location.href = 'https://tax.linkscloud.com.cn/'
    },
    goAbout () {
      this.$router.push({ name: 'about' })
    },
    noop () {}
  },
  mounted () {
    this.getList()
  }
}
</script>
<style scoped lang="less">
.task-container{
  background: #f6f8fc;
  min-height: calc(100% - 100px);
}
.banner{
  padding: 0;
  position: relative;
}
.banner .van-swipe{
  overflow: hidden;
  width: 100%;
  margin: 0;
}
.banner-swipe{
  width: 100vw;
}
.banner-img{
  width: 100%;
  height: 240px;
  display: block;
}
.banner-overlay{
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 80px;
  color: #fff;
  padding: 18px 20px;
  border-radius: 14px;
  background: none;
}
.overlay-title{
  font-size: 26px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.35);
}
.overlay-sub{
  margin-top: 10px;
  display: inline-block;
  font-size: 18px;
  line-height: 1.6;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255,255,255,0.18);
  backdrop-filter: blur(2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.18);
}
.banner .van-swipe__item{
  flex: 0 0 100%;
}
/* 轮播图上的搜索框样式 */
.banner-search{
  position: absolute;
  left: 16px;
  right: 16px;
  top: 16px;
  z-index: 2;
}
.banner-search :deep(.van-search){
  background: rgba(255,255,255,0.35);
  border-radius: 28px;
  padding: 6px 10px;
  backdrop-filter: blur(4px);
}
.banner-search :deep(.van-search__content){
  background: transparent;
}
.banner-search :deep(.van-field__control){
  color: #fff;
}
.banner-search :deep(.van-field__control::placeholder){
  color: rgba(255,255,255,0.9);
}
.shortcut-nav{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
  margin: 10px 20px 0;
  background: #fff;
  border-radius: 12px;
}
.shortcut-item{
  flex: 1;
  text-align: center;
}
.shortcut-icon{
  width: 56px;
  height: 56px;
  margin: 0 auto 8px;
  border-radius: 50%;
  background: #eaf2ff;
  color: #2a66ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
.icon-computer{
  width: 46px;
  height: 46px;
}
.shortcut-text{
  font-size: 14px;
  color: #333;
}
.section-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}
.section-title{
  font-size: 20px;
  font-weight: 600;
  color: #1f2d3d;
}
.section-title.emphasis{
  font-weight: 700;
  color: #162336;
  position: relative;
  padding-left: 12px;
}
.section-title.emphasis::before{
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 1.2em;
  border-radius: 999px;
  background: linear-gradient(135deg, #3b7cff, #5bb4ff);
}
.filter-bar .van-button{
  margin-left: 8px;
}
.job-card{
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.06);
  margin: 0 20px 16px;
  padding: 16px;
}
.job-main{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.job-left{
  flex: 1;
  padding-right: 12px;
  text-align: left;
}
.job-thumb{
  width: 84px;
  height: 84px;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 12px;
  flex: 0 0 auto;
}
.thumb-img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.job-desc-bottom{
  margin-top: 12px;
  background: #f5f7fa;
  padding: 10px 12px;
  border-radius: 12px;
  color: #4b5563;
  font-size: 14px;
  text-align: left;
}
.desc-text{
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  line-height: 1.5;
}
.job-title{
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 8px;
}
.job-meta{
  font-size: 13px;
  color: #8a93a0;
  margin-bottom: 8px;
}
.job-desc{
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.job-bottom{
  display: flex;
  align-items: center;
  color: #8a93a0;
  font-size: 12px;
}
.bottom-text{
  margin-left: 6px;
}
.job-right{
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}
.salary-badge{
  background: #eaf2ff;
  color: #2a66ff;
  border-radius: 16px;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 600;
}
.action-btns{
  display: flex;
  gap: 8px;
  margin-top: 16px;
}
.van-button.btn-outline{
  background: #fff;
  color:#fff;
  border-color: #2a66ff;
  border-radius: 18px;
  padding: 0 14px;
  height: 32px;
  font-size: 14px;
  line-height: 32px;
  font-weight: 400;
}
.van-button.btn-primary{
  background: #2a66ff;
  border-color: #2a66ff;
  color: #fff;
}
</style>
